export const FETCH_CONTRACTS = 'FETCH_CONTRACTS';
export const FETCH_CONTRACTS_SUCCESS = 'FETCH_CONTRACTS_SUCCESS';
export const FETCH_CONTRACTS_ERROR = 'FETCH_CONTRACTS_ERROR';

export const FETCH_CONTRACT_DETAIL = 'FETCH_CONTRACT_DETAIL';
export const FETCH_CONTRACT_DETAIL_SUCCESS = 'FETCH_CONTRACT_DETAIL_SUCCESS';
export const FETCH_CONTRACT_DETAIL_ERROR = 'FETCH_CONTRACT_DETAIL_ERROR';

export const CONTRACT_OPERATION_START = 'CONTRACT_OPERATION_START';
export const CONTRACT_OPERATION_END = 'CONTRACT_OPERATION_END';
export const FETCH_CONTRACTS_V2 = 'FETCH_CONTRACTS_V2';

export const FETCH_CONTRACT_TYPES = 'FETCH_CONTRACT_TYPES';
export const FETCH_PMA_CONTRACT_UNITS = 'FETCH_PMA_CONTRACT_UNITS';
export const FETCH_PMA_CONTRACT_UNITS_SUCCESS = 'FETCH_PMA_CONTRACT_UNITS_SUCCESS';
export const FETCH_PMA_CONTRACT_UNITS_ERROR = 'FETCH_PMA_CONTRACT_UNITS_ERROR';

export const FETCH_OFF_PLAN_PROJECTS = 'FETCH_OFF_PLAN_PROJECTS';
export const FETCH_OFF_PLAN_PROJECTS_SUCCESS = 'FETCH_OFF_PLAN_PROJECTS_SUCCESS';
export const FETCH_OFF_PLAN_PROJECTS_FAILURE = 'FETCH_OFF_PLAN_PROJECTS_FAILURE';

export const DOWNLOAD_OFF_PLAN_CONTRACT = 'DOWNLOAD_OFF_PLAN_CONTRACT';
export const DOWNLOAD_OFF_PLAN_CONTRACT_SUCCESS = 'DOWNLOAD_OFF_PLAN_CONTRACT_SUCCESS';
export const DOWNLOAD_OFF_PLAN_CONTRACT_FAILURE = 'DOWNLOAD_OFF_PLAN_CONTRACT_FAILURE';

export const DOWNLOAD_LEASE_PMA_CONTRACT = 'DOWNLOAD_LEASE_PMA_CONTRACT';
export const DOWNLOAD_LEASE_PMA_CONTRACT_SUCCESS = 'DOWNLOAD_LEASE_PMA_CONTRACT_SUCCESS';
export const DOWNLOAD_LEASE_PMA_CONTRACT_FAILURE = 'DOWNLOAD_LEASE_PMA_CONTRACT_FAILURE';

export const DOWNLOAD_CONTRACT_DETAIL_DOCUMENT = 'DOWNLOAD_CONTRACT_DETAIL_DOCUMENT';
export const DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_SUCCESS = 'DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_SUCCESS';
export const DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_FAILURE = 'DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_FAILURE';

export const FETCH_LAND_USE_MUSTAHA = 'FETCH_LAND_USE_MUSTAHA';
export const FETCH_LAND_USE_MUSTAHA_SUCCESS = 'FETCH_LAND_USE_MUSTAHA_SUCCESS';
export const FETCH_LAND_USE_MUSTAHA_FAILURE = 'FETCH_LAND_USE_MUSTAHA_FAILURE';

export const FETCH_PMA_PROPERTIES = 'FETCH_PMA_PROPERTIES';
export const OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_LOADING = 'OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_LOADING';
export const OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_SUCCESS = 'OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_SUCCESS';
export const OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_FAILURE = 'OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_FAILURE';

export const DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT = 'DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT';
export const DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_SUCCESS = 'DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_SUCCESS';
export const DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_FAILURE = 'DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_FAILURE';

export const UPDATE_PERMISSION_ERROR = 'UPDATE_PERMISSION_ERROR';
export const UPDATE_PERMISSION_LOADING = 'UPDATE_PERMISSION_LOADING';
